import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=5840466e&scoped=true"
import script from "./form-table.vue?vue&type=script&lang=js"
export * from "./form-table.vue?vue&type=script&lang=js"
import style0 from "./form-table.vue?vue&type=style&index=0&id=5840466e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840466e",
  null
  
)

export default component.exports